import React from "react";
import { Box, useTheme, useMediaQuery } from "@mui/material";
import BlogCard from "../../components/common/BlogCard/BlogCard";
import { useDispatch, useSelector } from "react-redux";
import { fetchBlogsAction } from "../../store/slices/blogSlice";
import BannerSection from "../../components/common/BannerSection";
import NewsLogoSection from "../HomePage/NewsLogoSection";
import Breadcrumb from "../../components/common/Breadcrumb/Breadcrumb";

const Blogs = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // ≤600px
  const isAbove1200 = useMediaQuery("(min-width:750px)"); // ≥750px
  const dispatch = useDispatch();
  const { list } = useSelector((state) => state.blog);

  React.useEffect(() => {
    dispatch(fetchBlogsAction());
  }, [dispatch]);

  const cards = React.useMemo(() => {
    const toText = (html) => {
      if (!html) return "";
      const tmp = document.createElement('div');
      tmp.innerHTML = html;
      return tmp.textContent || tmp.innerText || "";
    };
    return (Array.isArray(list) ? list : []).map((b) => ({
      id: b.id,
      image: b.banner_image,
      title: b.title,
      description: toText(b?.BlogDescs?.[0]?.description || '').slice(0, 160),
      date: b.createdAt,
    }));
  }, [list]);

  return (
    <Box>
      {/* Breadcrumb */}
      <Breadcrumb
        items={[
          { label: "Home", path: "/" },
          { label: "Blogs", path: null },
        ]}
      />

      {/* Header Section */}
      <Box sx={{ mb: isMobile ? "10px" : "40px", mt: isMobile ? "0" : "30px" }}>
        <BannerSection title="Latest Blogs" subtitle={isMobile ? "Together for Good" : "Let's Save India"} />
      </Box>

      {/* Blog Grid */}
      <Box
        sx={{ width: "100%", backgroundColor: "#FEFEFE", paddingBlock: "40px" }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: {
              xs: "1fr", // mobile → 1 per row
              sm: "repeat(2, 1fr)", // ≥600px → 2 per row
              md: "repeat(3, 1fr)", // ≥900px → 3 per row
              lg: "repeat(auto-fit, minmax(350px, 1fr))",
            },
            gap: "20px",
            width: "94.44%",
            maxWidth: "1440px",
            margin: "0px auto",
          }}
        >
          {cards.map((blog) => (
            <Box key={blog.id}>
              <BlogCard blogData={blog} />
            </Box>
          ))}
        </Box>
      </Box>

      {/* News Logo Section */}
      <Box sx={{ display: isMobile ? "none" : "block" }}>
        <NewsLogoSection />
      </Box>
    </Box>
  );
};

export default Blogs;
